import { atom } from "jotai";

import { $accessTokenFunc, $isAuthenticated } from "../authenication";
import { $docsApi } from "../docsapi/docsapi.atom";

export const $redeemStatus = atom(
	"redeeming" as "redeeming" | "success" | "unauthenticated" | "error"
);
export const $responseResult = atom(undefined as string | undefined);
export const $error = atom(null as unknown);

export const $redeemInviteToken = atom(null, async (get, set, inviteToken: string) => {
	const isAuthenticated = get($isAuthenticated);
	if (!isAuthenticated) {
		set($redeemStatus, "unauthenticated");
		return;
	}
	const docsApi = get($docsApi);
	const token = await get($accessTokenFunc)?.getAccessTokenSilently?.();
	if (!token) {
		set($redeemStatus, "unauthenticated");
		return;
	}
	try {
		const resp = await docsApi.invites.accept(inviteToken, token);
		set($responseResult, resp);
		set($redeemStatus, "success");
	} catch (error) {
		set($redeemStatus, "error");
		set($error, error);
	}
});
